var _path, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45 53v-44c0-2.2-1.8-4-4-4h-36c-2.2 0-4 1.8-4 4v44c0 2.2 1.8 4 4 4h36c2.209 0 4-1.791 4-4z",
    fill: "#ad6d40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#f8f8ff",
    height: 44,
    rx: 1,
    width: 36,
    x: 5,
    y: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m31 5v3c0 1.1-.9 2-2 2h-12c-1.1 0-2-.9-2-2v-3c0-.55.45-1 1-1h3.13c.44-1.73 2.01-3 3.87-3s3.43 1.27 3.87 3h3.13c.55 0 1 .45 1 1z",
    fill: "#cbcbf4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m59 29.96v27.04c0 1.1-.9 2-2 2h-30c-1.1 0-2-.9-2-2v-27.04z",
    fill: "#ea9453"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m58.695 29.237-5.934-5.934c-.194-.194-.456-.303-.73-.303h-20.061c-.274 0-.537.109-.73.303l-5.934 5.934c-.651.651-.19 1.763.73 1.763h31.93c.92 0 1.381-1.112.73-1.763z",
    fill: "#fcb36b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m47 31v7c0 .552-.448 1-1 1h-8c-.552 0-1-.448-1-1v-7l1-1h8z",
    fill: "#723535"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 5,
    rx: 1,
    width: 7,
    x: 29,
    y: 50
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m47 31-3-8h-4l-3 8z",
    fill: "#914747"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.707 49.293c-.391-.391-1.023-.391-1.414 0l-1 1c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293v3c0 .553.447 1 1 1s1-.447 1-1v-3c.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414z",
    fill: "#20295e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m55.707 50.293-1-1c-.391-.391-1.023-.391-1.414 0l-1 1c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293v3c0 .553.447 1 1 1s1-.447 1-1v-3c.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414z",
    fill: "#20295e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#43a867"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14 23c-.264 0-.519-.104-.707-.293l-2-2c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l1.138 1.138 3.323-4.985c.306-.46.926-.584 1.387-.277.46.307.584.927.277 1.387l-4 6c-.166.249-.436.411-.733.44-.033.003-.066.005-.099.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 35c-.264 0-.519-.104-.707-.293l-2-2c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l1.138 1.138 3.323-4.985c.306-.46.926-.584 1.387-.277.46.307.584.927.277 1.387l-4 6c-.166.249-.436.411-.733.44-.033.003-.066.005-.099.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 47c-.264 0-.519-.104-.707-.293l-2-2c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l1.138 1.138 3.323-4.985c.306-.46.926-.583 1.387-.277.46.307.584.927.277 1.387l-4 6c-.166.249-.436.411-.733.44-.033.003-.066.005-.099.005z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/Total Orders.b535ec6c390cd3b44996205a9e0bbeb4.svg";
export { ForwardRef as ReactComponent };